import React from 'react';

const JhLogoIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="44"
    height="45"
    viewBox="0 0 83.7 80"
    // style="enable-background:new 0 0 83.7 80;"
    style={{ enableBackground: 'new 0 0 83.7 80' }}
    xmlSpace="preserve"
  >
    {/* <style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00833E;}
	.st1{fill:#00833E;}
</style> */}
    <path
      fill="#ffffff"
      d="M40.9,11C25,11,12,24,12,39.9s13,28.9,28.9,28.9s28.9-12.9,28.9-28.9S56.9,11,40.9,11z M38.8,63.6l4-12.3h5.3
	l-4,12.2c-1.1,0.2-2.2,0.2-3.3,0.2C40.2,63.7,39.5,63.7,38.8,63.6L38.8,63.6z M51.4,61.3l9.3-28.5h-6.4l-4,12.4h-5.4l4-12.4h-6.4
	l-9.6,29.5C23.7,59,17.1,50.2,17.1,39.9c0-12.1,9-22,20.6-23.6l-7.5,23.1c-0.2,1-1.2,1.5-2.2,1.2c-0.9-0.3-1.4-1.3-1.1-2.2l1.8-5.6
	h-6.4l-1.2,3.7c-1.3,4.1,0.9,8.6,5.1,9.9s8.6-0.9,9.9-5.1l8.1-25C55.8,18,64.7,27.9,64.7,39.9C64.7,49.3,59.3,57.4,51.4,61.3
	L51.4,61.3z"
    />
    <g>
      <path
        fill="#ffffff"
        // class="st1"
        d="M63.8,12.4h-0.9V12h2.5v0.4h-0.9v2.7h-0.7L63.8,12.4z"
      />
      <path
        fill="#ffffff"
        // class="st1"
        d="M65.7,12h1l0.7,2.3l0,0l0.7-2.3H69v3.1h-0.6v-2.6l0,0l-0.8,2.6h-0.5l-0.8-2.6l0,0v2.6h-0.6L65.7,12L65.7,12z"
      />
    </g>
  </svg>
);

// const JhLogoIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="44"
//     height="45"
//     viewBox="0 0 44 45"
//   >
//     <defs>
//       <path id="a" d="M.563.335h44v44.148h-44z" />
//     </defs>
//     <g fill="none" fillRule="evenodd">
//       <g transform="translate(-1)">
//         <path
//           fill="#ffffff"
//           d="M21.51 40.314c.432.036.866.048 1.302.048.611 0 1.218-.023 1.815-.084l3.315-9.494h-3.218l-3.214 9.53zm9.364-1.914c5.724-2.977 9.64-9.02 9.64-15.994 0-8.778-6.22-16.092-14.423-17.653l-6.303 17.863s-1.63 5.838-8.068 4.61c-7.605-1.465-2.904-10.135-2.904-10.135h5.028s-.932 2.416-1.261 3.61c-.4 1.421 1.562 1.896 2.07.482.516-1.419 5.727-16.568 5.727-16.568C11.755 5.82 5.113 13.327 5.113 22.406c0 7.53 4.575 13.978 11.044 16.645l7.749-22.157h5.657l-2.82 8.372h3.019l3.018-8.372h5.635L30.875 38.4zM1.06 22.406C1.06 10.22 10.803.335 22.812.335c12.02 0 21.751 9.884 21.751 22.071 0 12.194-9.73 22.077-21.751 22.077-12.009 0-21.752-9.883-21.752-22.077z"
//           mask="url(#b)"
//         />
//       </g>
//       <path
//         fill="#ffffff"
//         d="M42.527 4V1.495h-.014L41.574 4h-.299l-.938-2.505h-.014V4h-.473V1h.73l.855 2.279L42.277 1H43v3h-.473zM38.37 1.4V4h-.473V1.4H37V1h2.266v.4h-.896z"
//       />
//     </g>
//   </svg>
// );

export default JhLogoIcon;
